/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ConsumedPointsStore } from '../stores/ConsumedPointsStore';

export const ConsumedPointsContext = createContext<ConsumedPointsStore>({} as ConsumedPointsStore);
